import type { FunctionComponent } from 'react';
import Content from './Content';

import useCheckQuote from './useCheckQuote';

const Quote: FunctionComponent = function () {
  const { isLoading, isUserLoggedIn } = useCheckQuote();

  if (isLoading || !isUserLoggedIn) return null;

  return <Content />;
};

Quote.displayName = 'Quote-view';

export default Quote;
